import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement>;

function IconBase({ children, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      {children}
    </svg>
  );
}

export function PauseIcon(props: IconProps) {
  return <IconBase {...props}><path d="M8 5v14M16 5v14" /></IconBase>;
}

export function PlayIcon(props: IconProps) {
  return <IconBase {...props}><path d="m9 6 9 6-9 6Z" /></IconBase>;
}

export function LiveIcon(props: IconProps) {
  return <IconBase {...props}><circle cx="12" cy="12" r="7" /><circle cx="12" cy="12" r="2" fill="currentColor" stroke="none" /></IconBase>;
}

export function ExploreIcon(props: IconProps) {
  return <IconBase {...props}><circle cx="10.5" cy="10.5" r="6.5" /><path d="m15.5 15.5 4 4" /></IconBase>;
}

export function SoundIcon({ muted = false, ...props }: IconProps & { muted?: boolean }) {
  return <IconBase {...props}><path d="M5 10v4h3l4 3V7l-4 3H5Z" />{muted ? <path d="m16 9 4 6m0-6-4 6" /> : <><path d="M15 9.5a4 4 0 0 1 0 5" /><path d="M17.5 7a7 7 0 0 1 0 10" /></>}</IconBase>;
}

export function ShareIcon(props: IconProps) {
  return <IconBase {...props}><path d="M12 16V4m0 0L8 8m4-4 4 4" /><path d="M6 12v7h12v-7" /></IconBase>;
}

export function OverviewIcon(props: IconProps) {
  return <IconBase {...props}><path d="M4 16c2-7 5-10 8-10s6 3 8 10" /><path d="M4 19h16" /></IconBase>;
}

export function HistoryIcon(props: IconProps) {
  return <IconBase {...props}><circle cx="12" cy="12" r="8" /><path d="M12 7v5l3 2" /></IconBase>;
}

export function ChevronIcon(props: IconProps) {
  return <IconBase {...props}><path d="m7 10 5 5 5-5" /></IconBase>;
}

export function MinusIcon(props: IconProps) {
  return <IconBase {...props}><path d="M5 12h14" /></IconBase>;
}

export function PlusIcon(props: IconProps) {
  return <IconBase {...props}><path d="M5 12h14M12 5v14" /></IconBase>;
}

export function CenterIcon(props: IconProps) {
  return <IconBase {...props}><path d="M8 4H4v4m12-4h4v4M8 20H4v-4m12 4h4v-4" /><circle cx="12" cy="12" r="2" /></IconBase>;
}

export function EyeOffIcon(props: IconProps) {
  return <IconBase {...props}><path d="M3 3l18 18M10.6 10.7a2 2 0 0 0 2.7 2.7M9.8 5.2A10.5 10.5 0 0 1 21 12a12 12 0 0 1-3 4.1M6.2 6.2A12 12 0 0 0 3 12a10.6 10.6 0 0 0 10.8 6.8" /></IconBase>;
}
